// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var ArticlesListVersion;
(function (ArticlesListVersion) {
    ArticlesListVersion["Text"] = "text";
    ArticlesListVersion["Thumbnails"] = "thumbnails";
})(ArticlesListVersion || (ArticlesListVersion = {}));
